import BaseError from './BaseError';
export default class OpmlError extends BaseError {
    constructor(opmlResponse) {
        super(opmlResponse.statusText);
        Object.setPrototypeOf(this, OpmlError.prototype);
        this.name = 'OpmlError';
        this.message = opmlResponse.statusText;
        this.statusCode = opmlResponse.status;
        this.faultCode = opmlResponse.faultCode;
    }
}
export function handleOpmlError(response) {
    const head = response.data.head;
    if (head && head.status >= 300) {
        throw new OpmlError(head);
    }
    return response;
}
